import cn from "classnames";
import { userMessageTypes, userMessageTypesEnum } from "helpers/enums";
import { ymEvent } from "helpers/system";
import Gear from "icons/planning/gear.svg";
import { UmamiManager } from "lib/umami";
import React, { useCallback, useEffect, useState } from "react";

const filteredUserMessageTypes = userMessageTypes.filter((item) =>
    [
        userMessageTypesEnum.PointVisiting,
        userMessageTypesEnum.BidRefuelingPointArrival,
        userMessageTypesEnum.BidLateness,
        userMessageTypesEnum.RouteEvents,
        userMessageTypesEnum.CarStopped,
        userMessageTypesEnum.TemperatureMonitoring,
    ].includes(item.value),
);

export default function NotificationsGear(props) {
    const [opened, setOpened] = useState(false);
    const handlePopoverToggle = useCallback(() => {
        UmamiManager.track("LatestEventsColumnHeaderSettingsIconClicked");

        if (!opened) {
            ymEvent("TripPlanningNotificationsConfigured");
        }
        setOpened((open) => !open);
    }, [opened]);

    useEffect(() => {
        return () => document.removeEventListener("click", onClickOutside);
    }, []);

    const onClickOutside = (e) => {
        if (!e.target.closest(".p-table__head-popover")) {
            setOpened(false);
            document.removeEventListener("click", onClickOutside);
        }
    };

    useEffect(() => {
        props.setBlurred(opened);
        const timeoutId = setTimeout(() => {
            if (opened) {
                document.addEventListener("click", onClickOutside);
            } else {
                document.removeEventListener("click", onClickOutside);
            }
        }, 0);
        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener("click", onClickOutside);
        };
    }, [opened]);

    const handleCheckboxClickWrapper = (callback) => {
        UmamiManager.track("LatestEventsColumnHeaderSortingFieldClicked");
        ymEvent("TripPlanningNotificationsConfigured");

        callback();
    };

    return (
        <div className="cursor-pointer">
            <Gear className="p-table__head-icon pl-1 p-table__icon-stroke" onClick={handlePopoverToggle} />
            {opened && (
                <div className="p-table__head-popover popover">
                    <div className="text-muted pb-1">Выберите события, которые для вас важны</div>
                    {filteredUserMessageTypes.map((item) => (
                        <div
                            key={item.value}
                            onClick={() =>
                                handleCheckboxClickWrapper(() =>
                                    props.setNotificationsFilter({
                                        ...props.notificationsFilter,
                                        [item.value]: !props.notificationsFilter[item.value],
                                    }),
                                )
                            }
                            className={cn("p-table__head-popover--item", {
                                "p-table__head-popover--item-selected": props.notificationsFilter[item.value],
                            })}
                        >
                            <div
                                className={cn("p-table__checkbox", {
                                    "p-table__checkbox--checked": props.notificationsFilter[item.value],
                                })}
                            />
                            {item.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
